import { IconButton, type IconButtonProps } from '@mui/material';
import type { ReactNode } from 'react';

type AccordionSummaryActionIconButtonProps = Omit<
  IconButtonProps,
  'component' | 'tabIndex' | 'onClick' | 'size'
> & {
  onAction?: () => void;
  children: ReactNode;
};

export const AccordionSummaryActionIconButton = ({
  onAction,
  disabled,
  children,
  ...rest
}: AccordionSummaryActionIconButtonProps) => (
  <IconButton
    component="span"
    tabIndex={-1}
    size="small"
    disabled={disabled}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();

      if (disabled) {
        return;
      }

      onAction?.();
    }}
    {...rest}
  >
    {children}
  </IconButton>
);
